import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { categories, domains } from '@/mocks/domains';
import { articles } from '@/mocks/articles';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '狼友域名',
  url: 'https://langyouyuming.com/',
  description: '狼友域名是专为站长和资源爱好者打造的域名导航聚合平台，提供最新可用狼友域名地址、镜像备用链接及防失联入口。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://langyouyuming.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '狼友域名',
  url: 'https://langyouyuming.com/',
  description: '专业域名导航与资源聚合平台',
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'contact@langyouyuming.com',
    contactType: 'customer service',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '如何获取狼友域名最新地址？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '收藏本导航页面即可实时获取最新可用狼友域名地址。我们提供主域名、镜像域名、备用入口和防失联域名等多种访问方式，确保您随时随地都能稳定访问。',
      },
    },
    {
      '@type': 'Question',
      name: '狼友域名是否免费使用？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '狼友域名导航服务完全免费，无需注册即可使用。我们致力于为站长和资源爱好者提供便捷的域名导航服务，所有收录的域名地址均可直接访问。',
      },
    },
    {
      '@type': 'Question',
      name: '域名显示离线怎么办？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '如果某个域名显示离线，建议尝试使用其他可用的镜像域名或备用入口。我们提供多条线路保障，换一个域名通常就能正常访问。',
      },
    },
  ],
};

const recommendedDomains = domains.filter((d) => d.category === 'recommended' && d.status === 'online').slice(0, 6);
const latestArticles = articles.slice(0, 4);

export default function Home() {
  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          {/* Hero Section */}
          <section className="relative pt-32 pb-20 md:pt-40 md:pb-28 overflow-hidden">
            <div className="absolute inset-0">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20pattern%20with%20warm%20copper%20and%20cream%20tones%2C%20minimalist%20background%20with%20subtle%20texture%2C%20clean%20professional%20aesthetic%2C%20soft%20gradient%20with%20organic%20shapes%2C%20digital%20network%20nodes%20pattern%20in%20light%20warm%20colors&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
                alt=""
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-background-50/60 via-background-50/40 to-background-50"></div>
            </div>
            <div className="relative max-w-7xl mx-auto px-4 md:px-6 w-full">
              <div className="max-w-3xl mx-auto text-center">
                <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-accent-100/80 rounded-full mb-6">
                  <span className="w-2 h-2 bg-accent-500 rounded-full animate-pulse"></span>
                  <span className="text-xs font-medium text-accent-700">域名状态实时监控中</span>
                </div>
                <h1 className="font-heading text-3xl md:text-5xl text-foreground-950 leading-tight mb-5">
                  狼友域名
                  <span className="block text-xl md:text-2xl text-foreground-600 font-sans font-normal mt-2">
                    专业导航与资源聚合平台
                  </span>
                </h1>
                <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-xl mx-auto mb-8">
                  提供最新可用狼友域名地址、镜像备用链接及防失联入口。收录高质量资源站点，实时更新域名状态，帮助您快速找到稳定可访问的域名入口，永久书签收藏，告别失联烦恼。
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                  <Link
                    to="/category/recommended"
                    className="px-8 py-3 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-compass-line mr-2"></i>
                    浏览推荐域名
                  </Link>
                  <a
                    href="https://langyou-permanent.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-8 py-3 bg-background-50 text-foreground-700 rounded-full text-sm font-medium border border-background-300 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-bookmark-line mr-2"></i>
                    收藏永久入口
                  </a>
                </div>
              </div>
            </div>
          </section>

          {/* Stats Bar */}
          <section className="max-w-7xl mx-auto px-4 md:px-6 -mt-10 relative z-10">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
              {[
                { num: '200+', label: '收录域名', icon: 'ri-global-line' },
                { num: '50,000+', label: '服务用户', icon: 'ri-user-line' },
                { num: '99.9%', label: '平台在线率', icon: 'ri-check-double-line' },
                { num: '24h', label: '状态更新频率', icon: 'ri-time-line' },
              ].map((stat) => (
                <div key={stat.label} className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70 text-center">
                  <div className="w-9 h-9 mx-auto mb-2 flex items-center justify-center bg-accent-100 rounded-lg">
                    <i className={`${stat.icon} text-accent-600 text-sm`}></i>
                  </div>
                  <div className="text-xl md:text-2xl font-bold text-foreground-950">{stat.num}</div>
                  <div className="text-xs text-foreground-500 mt-0.5">{stat.label}</div>
                </div>
              ))}
            </div>
          </section>

          {/* Category Cards */}
          <section className="max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-20">
            <div className="text-center mb-10">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
                域名分类导航
              </h2>
              <p className="text-sm text-foreground-500 max-w-lg mx-auto">
                按类别浏览狼友域名，快速找到您需要的域名入口
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {categories.map((cat) => {
                const count = domains.filter((d) => d.category === cat.slug).length;
                const onlineCount = domains.filter((d) => d.category === cat.slug && d.status === 'online').length;
                return (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="group bg-background-50 rounded-xl p-5 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
                  >
                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 flex items-center justify-center bg-accent-100 rounded-xl group-hover:bg-accent-200 transition-colors flex-shrink-0">
                        <i className={`${cat.icon} text-accent-600 text-xl`}></i>
                      </div>
                      <div className="min-w-0">
                        <div className="flex items-center gap-2 mb-1">
                          <h3 className="font-heading text-lg text-foreground-950 whitespace-nowrap">{cat.name}</h3>
                          <span className="text-xs text-accent-600 bg-accent-100 px-2 py-0.5 rounded-full whitespace-nowrap">
                            {onlineCount}个可用
                          </span>
                        </div>
                        <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">{cat.description}</p>
                        <div className="flex items-center gap-1 mt-3 text-xs text-foreground-400">
                          <span>共 {count} 个域名</span>
                          <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
                        </div>
                      </div>
                    </div>
                  </Link>
                );
              })}
            </div>
          </section>

          {/* Recommended Domains */}
          <section className="bg-background-100 py-16 md:py-20">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-10">
                <div>
                  <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">
                    推荐域名
                  </h2>
                  <p className="text-sm text-foreground-500">精选稳定可用的狼友域名入口</p>
                </div>
                <Link
                  to="/category/recommended"
                  className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
                >
                  查看全部
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-product-shop>
                {recommendedDomains.map((domain) => (
                  <a
                    key={domain.id}
                    href={domain.url}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="group bg-background-50 rounded-xl p-5 border border-background-200/70 hover:border-accent-300 transition-all duration-300 cursor-pointer"
                  >
                    <div className="flex items-center justify-between mb-3">
                      <div className="flex items-center gap-2">
                        <div className="w-2 h-2 bg-accent-500 rounded-full"></div>
                        <span className="text-xs text-accent-600 font-medium">在线</span>
                      </div>
                      <span className="text-xs text-foreground-400">{domain.uptime}</span>
                    </div>
                    <h3 className="font-heading text-base text-foreground-950 mb-1.5">{domain.name}</h3>
                    <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">{domain.description}</p>
                    <div className="flex items-center justify-between">
                      <span className="text-xs text-foreground-400 truncate max-w-[180px]">{domain.url}</span>
                      <span className="text-xs text-accent-600 flex items-center gap-1 whitespace-nowrap">
                        <i className="ri-external-link-line"></i>
                        访问
                      </span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </section>

          {/* Latest Articles */}
          <section className="max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-20">
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-10">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">
                  最新文章
                </h2>
                <p className="text-sm text-foreground-500">域名知识、使用指南与技术科普</p>
              </div>
              <Link
                to="/article/how-to-access-langyou"
                className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
              >
                更多文章
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
              {latestArticles.map((article) => (
                <Link
                  key={article.slug}
                  to={`/article/${article.slug}`}
                  className="group bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-300 transition-all duration-300 overflow-hidden cursor-pointer"
                >
                  <div className="p-5">
                    <div className="flex items-center gap-2 mb-3">
                      <span className="text-xs bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded-full whitespace-nowrap">
                        {article.categoryName}
                      </span>
                      <span className="text-xs text-foreground-400">{article.date}</span>
                    </div>
                    <h3 className="font-heading text-base text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                      {article.title}
                    </h3>
                    <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center justify-between text-xs text-foreground-400">
                      <span><i className="ri-time-line mr-1"></i>{article.readTime}</span>
                      <span><i className="ri-eye-line mr-1"></i>{article.viewCount.toLocaleString()}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </section>

          {/* FAQ Section */}
          <section className="bg-background-100 py-16 md:py-20">
            <div className="max-w-3xl mx-auto px-4 md:px-6">
              <div className="text-center mb-10">
                <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
                  常见问题
                </h2>
                <p className="text-sm text-foreground-500">关于狼友域名的常见疑问解答</p>
              </div>
              <div className="space-y-3">
                {[
                  { q: '如何获取狼友域名最新地址？', a: '收藏本导航页面即可实时获取最新可用狼友域名地址。我们提供主域名、镜像域名、备用入口和防失联域名等多种访问方式，确保您随时随地都能稳定访问。' },
                  { q: '狼友域名导航服务是否免费？', a: '狼友域名导航服务完全免费，无需注册即可使用。我们致力于为站长和资源爱好者提供便捷的域名导航服务，所有收录的域名地址均可直接访问。' },
                  { q: '域名显示离线怎么办？', a: '如果某个域名显示离线，建议尝试使用其他可用的镜像域名或备用入口。我们提供多条线路保障，换一个域名通常就能正常访问。如长时间离线，可联系客服获取最新信息。' },
                ].map((faq, idx) => (
                  <details key={idx} className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden cursor-pointer">
                    <summary className="flex items-center justify-between p-5 font-medium text-foreground-950 text-sm list-none">
                      <span>{faq.q}</span>
                      <i className="ri-add-line text-foreground-400 group-open:hidden"></i>
                      <i className="ri-subtract-line text-foreground-400 hidden group-open:block"></i>
                    </summary>
                    <div className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                      {faq.a}
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section className="relative py-20 md:py-24 overflow-hidden">
            <div className="absolute inset-0">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20with%20copper%20and%20cream%20flowing%20shapes%2C%20minimalist%20geometric%20network%20pattern%2C%20soft%20ambient%20light%2C%20clean%20professional%20background%20with%20subtle%20texture%2C%20digital%20connection%20nodes%20in%20warm%20earthy%20tones&width=1800&height=600&seq=cta-bg-2026&orientation=landscape"
                alt=""
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-background-50/70 via-background-100/50 to-background-50"></div>
            </div>
            <div className="relative max-w-2xl mx-auto text-center px-4 md:px-6">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">
                告别失联烦恼，从这里开始
              </h2>
              <p className="text-foreground-600 text-sm md:text-base mb-8">
                收藏狼友域名导航页，获取最新最全的域名入口信息，永不失联
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <a
                  href="https://langyou-permanent.com"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="px-8 py-3 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-bookmark-line mr-2"></i>
                  收藏永久入口
                </a>
                <Link
                  to="/about"
                  className="px-8 py-3 bg-background-50 text-foreground-700 rounded-full text-sm font-medium border border-background-300 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-information-line mr-2"></i>
                  了解更多
                </Link>
              </div>
            </div>
          </section>
        </main>

        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
}